import { render, staticRenderFns } from "./RecordBase.vue?vue&type=template&id=73d4618d&scoped=true"
import script from "./RecordBase.vue?vue&type=script&lang=js"
export * from "./RecordBase.vue?vue&type=script&lang=js"
import style0 from "./RecordBase.vue?vue&type=style&index=0&id=73d4618d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d4618d",
  null
  
)

export default component.exports